import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { type ActionsObservable } from 'redux-observable';
import { type Action, type MiddlewareAPI } from 'redux';
import { empty } from 'rxjs/observable/empty';

import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { SET_FIRST_SPACE_CREATED_FLAG } from '../actions';

import { putFirstSpaceCreatedFlag$ } from './requests';
import { type State } from '../types';
import { getProjectId, getProjectType } from '../project/selectors';

export default (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(SET_FIRST_SPACE_CREATED_FLAG).switchMap(() =>
		putFirstSpaceCreatedFlag$(getProjectId(store.getState()), getProjectType(store.getState()))
			.switchMap(() => {
				fetchSuccess('confluence.first.space.created.flag');
				return empty<Action>();
			})
			.catch((err) => {
				fetchFailed('confluence.first.space.created.flag', err);
				return empty<Action>();
			}),
	);
